import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesComponent } from './files.component';
import { FileComponent } from './components/file/file.component';
import { SharedModule } from '../shared/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { FileuUploadAreaComponent } from './components/fileuUploadArea/fileuUploadArea.component';
import { FileUploadItemComponent } from './components/fileUploadItem/fileUploadItem.component';
import { SelectSingleFileDialogComponent } from './components/selectSingleFileDialog/selectSingleFileDialog.component';
import { SelectableFileComponent } from './components/selectableFile/selectableFile.component';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DeleteFileDialogComponent } from './components/file/delete-file-dialog/delete-file-dialog/delete-file-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatExpansionModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule
  ],
  declarations: [
    DeleteFileDialogComponent,
    FilesComponent,
    FileComponent,
    FileuUploadAreaComponent,
    FileUploadItemComponent,
    SelectSingleFileDialogComponent,
    SelectableFileComponent,
  ],
  exports: [
    DeleteFileDialogComponent,
    FilesComponent,
    FileuUploadAreaComponent,
    SelectSingleFileDialogComponent,
    SelectableFileComponent]
})
export class FilesModule { }

